import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { IBooking } from '../../Models/DTO/Booking.models';

interface CustomerBookingState {
  active: IBooking[] | null;
  cancelled: IBooking[] | null;
  past: IBooking[] | null;
}

const INITIAL_STATE: CustomerBookingState = {
  active: null,
  cancelled: null,
  past: null,
};

export default (state = INITIAL_STATE, action: INeoAction): CustomerBookingState => {
  const { status, payload, name } = action;

  if (status === STATUS.SUCCESS) {
    if (name === REQUEST_ACTIONS.ACTIVE_CUSTOMER_BOOKINGS) {
      return {
        ...state,
        active: payload,
      };
    }

    if (name === REQUEST_ACTIONS.CANCELLED_CUSTOMER_BOOKINGS) {
      return {
        ...state,
        cancelled: payload,
      };
    }

    if (name === REQUEST_ACTIONS.PAST_CUSTOMER_BOOKINGS) {
      return {
        ...state,
        past: payload,
      };
    }
  }

  return state;
};
